module.exports = __webpack_public_path__ + "img/Group.8fc466c5.svg";